import { useSyncExternalStore } from 'react'

// The app's one breakpoint: below 768 px is mobile (Tailwind `md`, DESIGN_SYSTEM
// "Responsive Breakpoints"). For layout that only CSS can change, use the
// `md:` classes; this is for content that differs, such as a label.
const QUERY = '(min-width: 768px)'

function subscribe(onChange: () => void): () => void {
  const mql = window.matchMedia(QUERY)
  mql.addEventListener('change', onChange)
  return () => mql.removeEventListener('change', onChange)
}

export function useIsDesktop(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  )
}
